module.exports = __webpack_public_path__ + "static/media/PartnerGoogleLogo.fcad950d.png";